<template>
  <div class="page-container">
    <Page v-bind="$attrs" class-name="ypage" ref="pageRef" :total="total">
      <template #[slotName] v-for="(slot, slotName) in $slots">
        <slot :name="slotName"></slot>
      </template>
      <span>{{ $t('page.Total') }} {{ props.total }} {{ $t('page.Search Results') }}</span>
    </Page>
    <span class="total-page-size" v-show="props.showTotalPage">/{{ pageRef.allPages }}</span>
  </div>
</template>
<script setup>
import { ref } from 'vue'
import '../css/page.css'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const props = defineProps({
  total: {
    type: [Number, String],
    default: 0
  },
  showTotalPage: {
    type: Boolean,
    default: true
  }
})
const pageRef = ref({ allPages: 0 })
</script>
<style lang="less" scoped>
.page-container {
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.total-page-size {
  font-size: 14px;
  font-weight: normal;
}
/* .ypage {
  margin: 8px 0px 8px 0;
} */
</style>
